export const searchHasValue = (search: SearchState) => {
  return search?.searchTerm?.length !== 0;
};
